import React from 'react';
import { Col, Container, Row } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeroSectionContentStyled } from '../styled';
export function HeroSectionContentSkeleton() {
    const { isInfiniteDesktopView, isMobileView } = useWindowSize();
    const containerHeight = isInfiniteDesktopView ? 'calc(100% - 48px)' : '100%';
    return (React.createElement(Container, { height: "100%" },
        React.createElement(FlexWrapper, { flexDirection: "column", justifyContent: "space-between", height: containerHeight, pt: "16px", pbDesktop: "48px", pbMobile: "16px", pbTablet: "24px" },
            React.createElement(HeroSectionContentStyled, null,
                React.createElement(Row, null,
                    React.createElement(Col, { lg: 6, md: 8 },
                        React.createElement(Skeleton, { skeletonProps: {
                                height: isMobileView ? 16 : 24,
                                width: isMobileView ? '40%' : 200,
                            } }),
                        React.createElement(Skeleton, { skeletonProps: {
                                height: isMobileView ? 32 : 56,
                                width: isMobileView ? '50%' : 300,
                            }, wrapperProps: {
                                mtS: 4,
                            } }),
                        !isMobileView && (React.createElement(React.Fragment, null,
                            React.createElement(Skeleton, { skeletonProps: {
                                    height: 20,
                                    width: 100,
                                }, wrapperProps: {
                                    mtS: 24,
                                } }),
                            React.createElement(Skeleton, { skeletonProps: {
                                    height: 32,
                                    width: 200,
                                } }),
                            React.createElement(Skeleton, { skeletonProps: {
                                    height: 44,
                                    width: 300,
                                }, wrapperProps: {
                                    mtS: 24,
                                } })))))))));
}
